import React from 'react';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import { PulseLoader } from 'react-spinners';

//redux
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectIsLoadingDepartments } from '../../redux/admin/admin-selector'

import { LoginContext } from '../../services/api/authentication-api';

import './column-filter-panel.scss';

class ColumnFilterPanel extends React.Component {

    constructor(Props) {
        super(Props);

        this.state = {
            list: this.props.list,
            selected: this.props.selected ?? [],
            allKeys: {},
            filter: "",
            loading: false
        }
        //closes dropdown when you click outside
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount = () => {
        const {loadingType, isLoadingDepartments} = this.props

        if (loadingType === 'departments') {
            this.setState({
                loading: isLoadingDepartments
            })
        }
        
        document.addEventListener('mousedown', this.handleClickOutside);

        let allKeys = this.state.allKeys;

        for (let i in this.state.list) {
            if (allKeys[this.state.list[i][this.props.nameParameter].toLowerCase()] !== undefined) {
                allKeys[this.state.list[i][this.props.nameParameter].toLowerCase()].push(this.state.list[i]);
			}
            else {
                allKeys[this.state.list[i][this.props.nameParameter].toLowerCase()] = [this.state.list[i]];     
			}
        }
        
        this.setState({ allKeys: allKeys });
    }

    componentWillUnmount = () => {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    ToggleAll = () => {
        // if all is checked
        if (this.state.selected.length === Object.keys(this.state.allKeys).length) {
            this.setState({
                selected: [],
            });
        }
        else {

            let selected = [];
            Object.keys(this.state.allKeys).forEach((key) => {
                selected.push(this.state.allKeys[key])
            })
            this.setState({
                selected: selected
            });
        }
    }

    ToggleRow = (item) => {

        let selected = this.state.selected;

        if (selected.findIndex(a => a[0][this.props.nameParameter] === item[0][this.props.nameParameter]) > -1) {
            selected.splice(selected.findIndex(a => a[0][this.props.nameParameter] === item[0][this.props.nameParameter]), 1);
        }
        else {
            selected.push(item);
        }
        
        this.setState({
            selected: selected,
        })

    }

    saveAndHide = () => {
        this.props.save(this.state.selected, this.props.listName, this.props.filteredListName, this.props.column, this.props.value, this.props.idParameter, false);
        this.props.close();
    }

    clearAndHide = () => {
        this.setState({
            selected: []
        });
        this.props.save([], this.props.listName, this.props.filteredListName, this.props.column, this.props.value, this.props.idParameter, true);
        this.props.close();
    }

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.props.close();
        }
    }


    filterSearchedItems = () => {
        let filteredAllItems = [];
        let curUser = [];
        let curIndex = 0;

        Object.keys(this.state.allKeys).forEach((key) => {
            if (key.includes(this.state.filter.toLowerCase())) {
                filteredAllItems.push(this.state.allKeys[key]);    
            }
        })

        let selectAll =
            this.state.filter === "" ?
                <div className="projects-row">

                    <Form.Check className="checkbox" type={'checkbox'} inline checked={Object.keys(this.state.allKeys).length === this.state.selected.length} onChange={() => { this.ToggleAll() }} />
                    All {this.props.type}
                </div>
                : <></>
        if((this.props.type === "Users" || this.props.type === "Members") && filteredAllItems.length > 0){
            curUser = filteredAllItems.filter((user) => user[0].userID === this.context.userID);
            curIndex = filteredAllItems.indexOf(curUser[0]);
            if (curIndex !== -1) {
                let start = filteredAllItems.slice(0,curIndex+1);
                let end = filteredAllItems.slice(curIndex+2);

                start.unshift(start.pop());
                filteredAllItems = start.concat(end);
            }
        }

        return (
            <div>
                {selectAll}
                {filteredAllItems.map((item, idx) => {
                    return (
                        <div key={JSON.stringify(item) + " " + this.state.list.includes(item).toString()} className="projects-row">
                            <Form.Check className="checkbox" type={'checkbox'} inline checked={this.state.selected.findIndex(selectedItem => selectedItem[0][this.props.nameParameter] === item[0][this.props.nameParameter]) > -1} onChange={() => { this.ToggleRow(item) }} />
                            {idx === 0 && (this.props.type === "Users" || this.props.type === "Members") && curIndex !== -1 ? 
                            <div className="bold">
                                {"Me (" + item[0][this.props.nameParameter] + ")"}
                            </div>
                            :
                            <div>
                                {item[0][this.props.nameParameter]}
                            </div>
                            }
                        </div>
                    )
                })}
            </div>
        )
    }

    render = () => {
        const {loading} = this.state
        return (
            <LoginContext.Consumer>
                {
                    () => (
                        <Dropdown ref={this.setWrapperRef} show={this.props.show} className="project-name-selection-dropdown">

                            <Dropdown.Toggle className="task-column-filter-dropdown-btn" onClick={() => {this.props.change()}}></Dropdown.Toggle>

                            <div className="project-selection-wrapper">
                                <Dropdown.Menu className="projects-menu" >
                                    <div className="popup-header">Select {this.props.type}</div>
                                    <Button className="close-project-filter-btn" onClick={(e) => { this.props.close(e) }}></Button>
                                    <Form.Control className="select-project-search" onChange={(e) => { this.setState({ filter: e.target.value }) }} as="textarea" rows="1" placeholder={"Search " + this.props.type} />
                                    <div class="project-filter-count">{this.state.selected.length} {this.props.type} Selected</div>
                                    <div class="select-project-divider-line"></div>
                                    <Form.Group className="projects-form-group">
                                    {
                                        loading ? 
                                        <div style = {{'padding' : '30px 100px', 'textAlign' : 'center'}}>
                                            <PulseLoader></PulseLoader>
                                        </div>
                                        : 
                                        this.filterSearchedItems()
                                        }
                                    </Form.Group>
                                    <Button className="done-btn" onClick={() => this.saveAndHide()} variant="primary">Apply Filter</Button>
                                    <Button className="clear-filter-btn" onClick={() => this.clearAndHide()}>Clear Filter</Button>
                                </Dropdown.Menu>
                            </div>
                        </Dropdown>
                    )
                }
            </LoginContext.Consumer>
        )
    }
}

const mapState = createStructuredSelector({
    isLoadingDepartments: selectIsLoadingDepartments
})

ColumnFilterPanel.contextType = LoginContext;
export default connect(mapState, null)(ColumnFilterPanel);